import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { SharedModule } from '@shared/shared.module';
import { HD_LANG_RECOMPUTE_ON_LOAD, HdContentLanguageService } from '../bodygraph/hd-content-language.service';

/**
 * Zoekvak op chartnaam in de kopregel van een resultatenlijst (zie
 * `hd-chart-match-list`): filtert client-side over alle pagina's, zodat je in een
 * lange lijst snel ziet hoe het met één persoon zit. Enkel aangemaakt wanneer
 * de lijst meer treffers heeft dan op één pagina passen.
 */
@Component({
  selector: 'hd-chart-match-name-filter',
  standalone: true,
  imports: [SharedModule],
  template: `
    <e-search-input
      ngDefaultControl
      name="chart-match-name-filter"
      small
      border
      class="hd-chart-match-name-filter"
      [ngModel]="value()"
      [placeholder]="placeholder()"
      (ngModelChange)="valueChange.emit($event ?? '')"
    ></e-search-input>
  `,
  styles: `
    :host {
      display: block;
      flex: 1 1 140px;
      min-width: 120px;
      max-width: 220px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HdChartMatchNameFilterComponent {
  readonly value = input('');
  readonly valueChange = output<string>();

  private readonly transloco = inject(TranslocoService);
  private readonly contentLang = inject(HdContentLanguageService);
  private readonly lang = computed(() => this.contentLang.effectiveLang(), HD_LANG_RECOMPUTE_ON_LOAD);

  protected readonly placeholder = computed(() =>
    this.transloco.translate<string>('humanDesign.chartSearch.nameFilterPlaceholder', undefined, this.lang()));
}

/** Vergelijkt zonder hoofdletters en accenten ("Zoë" vindt ook "zoe"). */
export function hdNormalizeChartName(value: string): string {
  return value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
}
